import styled from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { getBicycleColor } from '@/utility/theme/bicycleColor';

export const Wrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridGap: `${defaultTheme.spacing.xs} 0`,
    width: ['100%', '100%', '200px', '200px'],
    padding: defaultTheme.spacing.s,
  }),
);

export const Field = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontSize: defaultTheme.font.size.xs,
    '& > span': {
      width: '30px',
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const BarWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 30px)',
    fontWeight: 'bold',
    '& > span': {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const PercentageBar = styled.div(
  (props: { now: number; bicycleNum: number; alpha?: number }) =>
    mq({
      width: `${props.now}%`,
      height: '12px',
      backgroundColor: rgba(
        props.bicycleNum === 1 ? '#A8A8A8' : getBicycleColor(props.bicycleNum),
        props.alpha || 1,
      ),
    }),
);
